import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUnionComponent } from "./med-icon-union.component";

@NgModule({
  declarations: [
    MedIconUnionComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUnionComponent,
  ],
})
export class MedIconUnionModule { }
